<template>
  <div class="bx-custom-datetime">
    <input v-model="model"
           type="datetime-local"
           :min="minDateTime"
           :max="maxDateTime"
           step="300">
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: [String, Boolean, Array],
      required: true
    }
  },
  emits: ['update:model-value'],
  computed: {
    model: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:model-value', value)
      }
    },
    minDateTime () {
      const now = new Date()
      now.setDate(now.getDate() - 2) // two days in the past
      return now.toISOString().slice(0, 16)
    },
    maxDateTime () {
      const now = new Date()
      now.setDate(now.getDate() + 13) // 13 days in the future
      return now.toISOString().slice(0, 16)
    }
  }
}
</script>
